<template lang="pug">
  BaseForm(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :form="form"
    :data="item"
    :update="updateItem"
    :create="createItem"
  )
</template>

<script>
import BaseForm from '@/components/app/BaseForm'
import { mapState, mapActions } from 'vuex'
import store from '@/store'

export default {
  components: { BaseForm },
  data: (vm) => ({
    title: vm.$t('contacts.edit', { id: vm.$route.params.contactId })
  }),
  computed: {
    ...mapState('contacts', ['routeKey', 'routes', 'form', 'item']),
    crumbs: vm => [
      { text: vm.$t('contacts.title'), to: { name: 'contacts.index' } },
      { text: vm.$t('contacts.edit', { id: vm.$route.params.contactId }) }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('contacts/fetchItem', { route: to })
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapActions('contacts', ['createItem', 'updateItem'])
  }
}
</script>
